import { rem, rgba } from 'polished';
import styled, { css } from 'styled-components';

import {
  IReferenceImageProps,
  IReferenceWrapperProps,
} from './Reference.types';

export const StyledDate = styled.div`
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-weight: 400;
`;

export const StyledDetails = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: ${({ theme }) => rem(theme.spacings.s)};
`;

export const StyledImage = styled.img<IReferenceImageProps>`
  height: ${({ imageHeight }) =>
    imageHeight ? rem(imageHeight) : rem('20px')};
  width: auto;
`;

export const StyledMessage = styled.p`
  margin: 0;
  padding: 0;
  padding-bottom: ${({ theme }) => rem(theme.spacings.s)};
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${({ theme }) => rem(theme.spacings.s)};
  font-weight: 400;
  border-bottom: 1px solid ${({ theme }) => theme.colors.cross.silverFox};

  strong {
    font-weight: 700;
  }
`;

export const StyledName = styled.strong`
  color: ${({ theme }) => theme.colors.cross.black};
  font-weight: 700;
`;

export const StyledRatingWrapper = styled.div`
  align-self: flex-end;
  margin-bottom: ${rem('6px')};
`;

export const StyledUserInfo = styled.div`
  margin-left: ${({ theme }) => rem(theme.spacings.xs)};
`;

export const StyledUserInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const ActiveCard = css`
  background-color: ${({ theme }) => theme.colors.main};
  border-radius: ${({ theme }) => rem(theme.spacings.s)};
  box-shadow: 0 0 ${rem('8px')} 0
    ${({ theme }) => rgba(theme.colors.cross.silverFox, 0.5)};
`;

export const StyledWrapper = styled.div<IReferenceWrapperProps>`
  display: flex;
  flex-direction: column;
  margin: ${({ theme }) => rem(theme.spacings.s)};
  padding: ${({ theme }) => rem(theme.spacings.s)};
  line-height: 1.4;
  transition: all 0.5s ease-in-out;

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => rem(theme.spacings.xs)};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.m}) {
    margin: ${rem('32px')};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    ${ActiveCard}
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin: 0;
    ${({ active }) => active && ActiveCard}
  }
`;
